import { QueryClient } from "@tanstack/react-query";
import { API_BASE_URL } from "../config.js";
import api from "./http.js";

export const queryClient = new QueryClient();

export async function signin(credentials) {
  const response = await fetch(`${API_BASE_URL}/auth/api/v1/token/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  });

  if (!response.ok) {
    const error = new Error("An error occurred on login");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }
  return response.json();
}

// export async function fetchHouseList({ selectedCompanyId,page = 1, pageSize = 12 }) {
//   const response = await api.get(
//     `/adminapp/get_all_houses/?page=${page}&page_size=${pageSize}`
//   );

//   const houses = await response.data;

//   return {
//     results: houses.results,
//     totalCount: houses.count,
//     next: houses.next,
//     previous: houses.previous,
//   };
// }

export async function fetchHouseList({
  selectedCompanyId,
  page = 1,
  pageSize = 12,
}) {
  const params = new URLSearchParams({
    page: page,
    page_size: pageSize,
  });

  if (selectedCompanyId) {
    params.append("sells_id", selectedCompanyId);
  }
  const response = await api.get(
    `/adminapp/get_all_houses/?${params.toString()}`,
  );

  const houses = await response.data;

  return {
    results: houses.results,
    totalCount: houses.count,
    next: houses.next,
    previous: houses.previous,
  };
}

export async function updateHouse(houseData) {
  
  const config = {};
  if (houseData instanceof FormData) {
    config.headers = { "Content-Type": "multipart/form-data" };
  }
  const response = await api.put(`/adminapp/house_detail/`, houseData, config);
  return response;
}

// ********** | Search

export const fetchSearchResults = async (searchText) => {
  const response = await api.get(
    `/adminapp/search_by_poster/?name=${searchText}`,
  );
  const searchResults = await response.data;
  return searchResults;
};

export async function fetchApprovedList({
  searchText,
  page = 1,
  pageSize = 10,
}) {
  const response = await api.get(
    `/adminapp/get_info_based_on_approval/?page=${page}&page_size=${pageSize}&query=${searchText}`,
  );

  const approvedHouses = await response.data;
  return {
    results: approvedHouses.results,
    totalCount: approvedHouses.count,
    next: approvedHouses.next,
    previous: approvedHouses.previous,
  };
}

export async function fetchApproveList({
  searchText,
  page = 1,
  pageSize = 10,
}) {
  const response = await api.get(
    `/adminapp/get_info_based_on_not_approval/?page=${page}&page_size=${pageSize}&query=${searchText}`,
  );

  const approveHouses = await response.data;
  return {
    results: approveHouses.results,
    totalCount: approveHouses.count,
    next: approveHouses.next,
    previous: approveHouses.previous,
  };
}

export async function fetchCustomerList({
  searchText,
  page = 1,
  pageSize = 12,
}) {
  const response = await api.get(
    `/adminapp/get_all_customers/?query=${searchText}&page=${page}&page_size=${pageSize}`,
  );

  const customerList = await response.data;
  return {
    results: customerList.results,
    totalCount: customerList.count,
    next: customerList.next,
    previous: customerList.previous,
  };
}

// in utils/api.js

export async function fetchAgentList({ sells_id, searchText, page, pageSize }) {
  const params = new URLSearchParams({
    page: page,
    page_size: pageSize,
  });

  if (searchText) {
    params.append("query", searchText);
  }

  if (sells_id) {
    params.append("sells_id", sells_id);
  }

  const url = `/adminapp/agent_data/?${params.toString()}`;
  const response = await api.get(url);
  return response.data;
}

export async function fetchAgentDetail(agentId) {
  const response = await api.get(`/adminapp/agent_detail/?agent_id=${agentId}`);

  const agentDetail = await response.data;
  return agentDetail;
}

// ************** [ Processed Reservation ] ***********************

export async function fetchProcessedReservation({
  date,
  page = 1,
  pageSize = 10,
}) {
  const response = await api.get(
    `/customer_service/api/reservations/?date=${date}&page=${page}&page_size=${pageSize}`,
  );

  const processedReserve = await response.data;

  return {
    results: processedReserve.results,
    totalCount: processedReserve.count,
    next: processedReserve.next,
    previous: processedReserve.previous,
  };
}

export async function addAgent(fields) {
  const response = await api.post(`/adminapp/agent_data/`, fields, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
}

export async function updateAgent(fields, agentId) {
  const config = fields instanceof FormData ? { headers: { "Content-Type": "multipart/form-data" } } : {};
  const response = await api.put(`/adminapp/agent_data/${agentId}/`, fields, config);
  return response.data;
}

// ************** [ Delete ] ***********************

export async function deleteNotApproved(houseID) {
  const response = await api.delete(`/adminapp/house_detail/?houseID=${houseID}`);
  return response.data;
}

// ********** [ Delete Agent ] *************

export async function deleteAgent(agentID) {
  const response = await api.delete(
    `/adminapp/agent_detail/?agent_id=${agentID}`,
  );
  return response;
}

// ********** | Delete Customer

export async function deleteCustomer(customerID) {
  const response = await api.delete(
    `/adminapp/customer_detail/?customerID=${customerID}`,
  );
  return response;
}

// ********** | Deactivate Agent

export async function deactivateAgent(agentID, isActive) {
  const response = await api.put(`/adminapp/agent_activation/${agentID}/`, {
    isActive,
  });
  return response;
}

// ********** | Approve/Disapprove a House

export async function approveHouse({ houseID, isApproved }) {
  // console.log("houseID", houseID);
  // console.log("isApproved", isApproved);

  const response = await api.put(
    `/adminapp/house_detail/?houseID=${houseID}&isApproved=${isApproved}`,
  );
  // if (!response.ok) {
  //   const error = new Error("An error occurred on approving a house");
  //   error.code = response.status;
  //   error.info = await response.json();
  //   throw error;
  // }
  return response.data;
}

// ************ | House report stat

export async function agentHouseStat(agentId) {
  const response = await api.get(
    `/adminapp/report/agent/total_house_count/${agentId}/`,
  );
  const agentHouseStat = await response.data;
  return agentHouseStat;
}

// ************ | Transactions

export async function transactions(id) {
  const response = await api.get(`/adminapp/transaction_list/?id=${id}`);

  const transactions = await response.data;
  return transactions;
}

// *************** | Deposite points

// export async function setPointDeposit(fields) {
//   console.log("setPointDeposit", fields);

//   const response = await api.post(`/adminapp/deposit_point/`,fields);
//   return response;
// }

// ********** | Report Dashboard

export async function fetchReport() {
  const response = await api.get(`${API_BASE_URL}/adminapp/report/`);

  const report = await response.data;

  return {
    totalReservation: report.total_reservation,
    totalRoom: report.total_room,
    totalAgents: report.total_agents,
    totalHouses: report.total_houses,
    totalTransactions: report.total_transactions,
    totalAbortedTransactions: report.total_aborted_transactions,
    totalPoints: report.total_points,
  };
}

// ********** | Number of Room Report

export async function fetchRoomReport() {
  const response = await api.get(`/adminapp/number_of_room_status/`);

  const roomReport = await response.data;
  return {
    last7Days: roomReport.last_7_days,
    last30Days: roomReport.last_30_days,
    last60Days: roomReport.last_60_days,
  };
}

// ********** | Number of Customer Report

export async function fetchCustomerReport() {
  const response = await api.get(`/adminapp/number_of_customer_status/`);

  const customerReport = await response.data;
  // console.log("Room Report", customerReport);
  return {
    last7Days: customerReport.last_7_days,
    last30Days: customerReport.last_30_days,
    last60Days: customerReport.last_60_days,
  };
}

// ********** | Number of Agent Report

export async function fetchAgentReport() {
  const response = await api.get(`/adminapp/number_of_agent_status/`);

  const agentReport = await response.data;
  return {
    last7Days: agentReport.last_7_days,
    last30Days: agentReport.last_30_days,
    last60Days: agentReport.last_60_days,
  };
}

// ********** | Number of House Report

export async function fetchHouseReport() {
  const response = await api.get(`/adminapp/number_of_house_status/`);

  const houseReport = await response.data;
  return {
    last7Days: houseReport.last_7_days,
    last30Days: houseReport.last_30_days,
    last60Days: houseReport.last_60_days,
  };
}

// ********** | Number of Reservation Report

export async function fetchReservationReport() {
  const response = await api.get(`/adminapp/number_of_reservations_status/`);

  const reservationReport = await response.data;
  return {
    last7Days: reservationReport.last_7_days,
    last30Days: reservationReport.last_30_days,
    last60Days: reservationReport.last_60_days,
  };
}

// ********** | Agent Payment

export async function fetchAgentPayment({ page = 1, pageSize = 12 }) {
  const response = await api.get(
    `/adminapp/agent_payment_config/?page=${page}&page_size=${pageSize}`,
  );

  const agentPayment = await response.data;

  return {
    results: agentPayment.results,
    totalCount: agentPayment.count,
    next: agentPayment.next,
    previous: agentPayment.previous,
  };
}

// ********** | Get Processed Payment

export async function fetchProcessedPayment({ id, page = 1, pageSize = 12 }) {
  const response = await api.get(
    `/adminapp/process_payment/${id}/?page=${page}&page_size=${pageSize}`,
  );

  const processedPayment = await response.data;

  return {
    results: processedPayment.results,
    totalCount: processedPayment.count,
    next: processedPayment.next,
    previous: processedPayment.previous,
  };
}

// ********** | POST Process Payment

export async function postProcessPayment({ id }) {
  const response = await api.post(`/adminapp/process_payment/${id}/`);

  return response.json();
}

// ********** | Agent Payment Search

export const fetchAgentPaymentSearch = async (searchText) => {
  const response = await api.get(
    `/adminapp/search_by_poster/?name=${searchText}`,
  );
  const searchResults = await response.data;
  return searchResults;
};

// ********** | Add New Config

export async function addPaymentConfig(fields) {
  const response = await api.post(`/adminapp/agent_payment_config/`, fields);
  return response;
}

export async function imageOrder(fields) {
  const response = await api.post(
    `/adminapp/order_house_images/`,
    JSON.stringify(fields),
  );
  return response;
}

export async function setThumbnail(customerId, imageId) {
  const response = await api.post(`/adminapp/tumble_image_setter/`, {
    customer_id: customerId,
    image_id: imageId,
  });
  return response;
}

export async function ResetPass(email) {
  const response = await api.post(`/auth/api/v1/resetpass/`, email);
  return response;
}

// ********** | Discount table

export async function getRewardTable() {
  const response = await api.get(`/gift_and_bonus/api/v1/discount_config/`);
  const rewardResults = await response.data;
  return [rewardResults];
}

// ********** | Discount config

export async function addDiscountConfig(fields) {
  const response = await api.post(
    `/gift_and_bonus/api/v1/discount_config/`,
    fields,
  );

  return response;
}

// *********** | Change password functionality

export async function changePassword(fields) {
  const response = await api.post(`/authapp/api/v1/change_password/`, fields);
  return response;
}

// *********** | Giveaway fetch

export async function getGiveawayTable() {
  const response = await api.get(`/gift_and_bonus/api/v1/give_away/`);
  const giveawayResults = await response.data;
  return [giveawayResults];
}

// *********** | Giveaway Modal Config

export async function addGiveawayConfig(fields) {
  const response = await api.post(`/gift_and_bonus/api/v1/give_away/`, fields);

  return response;
}

// *********** | Giveaway winners

export async function getGiveawayWinners({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/gift_and_bonus/api/v1/lucky_winners/?page=${page}&page_size=${pageSize}`,
  );
  const giveawayWinners = await response.data;
  return giveawayWinners;
}

// *********** | Edit Discount

export async function editDiscount(fields) {
  const response = await api.put(
    `/gift_and_bonus/api/v1/discount_config/`,
    fields,
  );
  return response;
}

// *********** | Edit Giveaway

export async function editGiveaway(fields) {
  const response = await api.put(`/gift_and_bonus/api/v1/give_away/`, fields);
  return response;
}

// *********** | Setting Payment API

export async function getPaymentSetting() {
  const response = await api.get(`/adminapp/payment_transaction_rate/`);
  const getTransactionRate = await response.data;
  return getTransactionRate;
}

// *********** | Add Payment Rate API

export async function addPaymentConfigRate(fields) {
  const response = await api.post(
    `/adminapp/payment_transaction_rate/`,
    fields,
  );
  return response;
}

// *********** | Update Payment Rate API

export async function editPaymentConfigRate(fields) {
  const response = await api.put(`/adminapp/payment_transaction_rate/`, fields);
  return response;
}

export async function deletePaymentConfigRate() {
  const response = await api.put(`/adminapp/payment_transaction_rate/`);
  return response;
}

// *********** | fetch system admins

export async function fetchSystemAdmin() {
  const response = await api.get("/adminapp/system_admin/");
  const systemAdmins = await response.data;
  return systemAdmins;
}

export async function addSystemAdmin(fields) {
  const response = await api.post(`/adminapp/system_admin/`, fields);
  return response;
}

export async function editSystemAdmin(id, fields) {
  const response = await api.put(`/adminapp/system_admin/${id}/`, fields);
  return response;
}

// *********** | Sales Company Admin

export async function addSalesAdmin(fields) {
  const response = await api.post(
    `/sells_app/admin/api/v1/sells-profile/`,
    fields,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response;
}

export async function fetchSalesCompany() {
  const response = await api.get("/sells_app/admin/api/v1/sells-profile/");
  const salesAdmins = await response.data;
  return salesAdmins;
}

// *********** | Generate Lucky Number

export async function generateLuckyNumber() {
  const response = await api.post(
    `/gift_and_bonus/api/v1/generate_lucky_numbers/`,
  );
  return response;
}

// *********** | Translate Language

export async function translate({ id, data }) {
  const response = await api.post(
    `/adminapp/house_field_translation/${id}/`,
    data,
  );
  return response.data;
}

export async function fetchReferralConfig() {
  const response = await api.get(`/adminapp/referral_code_config/`);
  const referralConfig = await response.data;
  return referralConfig;
}

export async function editReferralConfig(fields) {
  const response = await api.put(`/adminapp/referral_code_config/`, fields);
  const referralConfig = await response.data;
  return referralConfig;
}

// *********** | Sales Stat Chart

export async function fetchSalesStat() {
  const response = await api.get(`/sells_app/api/v1/dashboard/stats/`);
  const salesStat = await response.data;
  return salesStat;
}

export async function fetchSalesAgents({ searchText }) {
  const response = await api.get(
    `/sells_app/api/v1/agents/?query=${searchText}`,
  );
  const salesAgents = await response.data;
  return salesAgents;
}

// *********** | Sales Profile
export async function getSellsProfiles() {
  const response = await api.get(`/sells_app/admin/api/v1/sells-profile/`);
  const sellsProfiles = await response.data;
  return sellsProfiles;
}

// *********** | Make a Reservation
export async function makeReservation({ reservationId, assigned_room }) {
  const response = await api.post(
    `/customer_service/api/accept_reservation_request/${reservationId}/`,
    { assigned_room },
  );
  return response.data;
}

// *********** | add Company Agent
export async function addCompanyAgent(fields) {
  const response = await api.post(`/sells_app/api/v1/agents/sells/`, fields);
  return response.data;
}

// *********** | add Company Agent
export async function deleteCompanyAgent({ agentId }) {
  const response = await api.delete(
    `/sells_app/api/v1/agents/sells/${agentId}/`,
  );
  return response.data;
}

// *********** | edit Company Agent
export async function editCompanyAgent({ agentId, payload }) {
  const response = await api.put(
    `/sells_app/api/v1/agents/sells/${agentId}/`,
    payload,
  );
  return response.data;
}

export async function fetchCompanyHouses({ filters, page = 1, pageSize = 12 }) {
  const response = await api.get(`/sells_app/api/v1/houses/`, {
    params: {
      ...filters,
      page,
      page_size: pageSize,
    },
  });
  const companyHouses = await response.data;
  return companyHouses;
}

// *********** | POST Change password

export async function changeSalesPassword(fields) {
  const response = await api.post(`/authapp/api/v1/change_password/`, fields);
  return response;
}

export async function fetchDemoRequests({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/adminapp/room_management_demo_schedule/?page=${page}&page_size=${pageSize}`,
  );
  const demoRequests = await response.data;
  return demoRequests;
}

export async function updateDemoRequestStatus({ id, status }) {
  const response = await api.put(
    `/adminapp/room_management_demo_schedule/${id}/`,
    {
      status,
    },
  );
  return response;
}

// *********** | Filter sells House List

export async function fetchSubscriptionActivation({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/adminapp/hotel-subscriptions-activation/?page=${page}&page_size=${pageSize}`,
  );
  const subActivations = await response.data;
  return subActivations;
}

export async function activateSubscription(fields) {
  const response = await api.post(
    `/adminapp/hotel-subscriptions-activation/`,
    fields,
  );
  return response;
}

export async function fetchSubscriptionTransaction({
  page = 1,
  pageSize = 10,
}) {
  const response = await api.get(
    `/adminapp/subscription-transactions/?page=${page}&page_size=${pageSize}`,
  );
  const subActivations = await response.data;
  return subActivations;
}

// *********** | Subscription Modules

export async function fetchSubscriptionModules({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/adminapp/module/?page=${page}&page_size=${pageSize}`,
  );
  const subModules = await response.data;
  return subModules;
}

export async function addSubscriptionModule(fields) {
  const response = await api.post(`/adminapp/module/`, fields);
  return response;
}

export async function deleteSubscriptionModule(id) {
  const response = await api.delete(`/adminapp/module/${id}/`);
  return response;
}

export async function editSubscriptionModule(id, fields) {
  const response = await api.put(`/adminapp/module/${id}/`, fields);
  return response;
}

// *********** | Subscription Features

export async function fetchSubscriptionFeatures({
  planId,
  page = 1,
  pageSize = 10,
}) {
  const response = await api.get(
    `/adminapp/feature/plan/${planId}/?page=${page}&page_size=${pageSize}`,
  );
  const subFeatures = await response.data;
  return subFeatures;
}

export async function createSubscriptionFeatures(featuresData) {
  try {
    const response = await api.post(`/adminapp/feature/`, featuresData);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to create features.",
    );
  }
}

export async function addSubscriptionFeature(fields) {
  const response = await api.post(`/adminapp/subscription-features/`, fields);
  return response;
}

export async function editSubscriptionFeature(id, fields) {
  const response = await api.put(`/adminapp/feature/${id}/`, fields);
  return response;
}

export async function deleteSubscriptionFeature(id) {
  const response = await api.delete(`/adminapp/feature/${id}/`);
  return response;
}

/************* Email config ***********/

export async function fetchEmailConfig({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/customer_service/api/reservation_notifier_email/?page=${page}&page_size=${pageSize}`,
  );
  const emails = await response.data;
  return emails;
}

export async function createEmailNotifier(fields) {
  const response = await api.post(
    `/customer_service/api/reservation_notifier_email/`,
    fields,
  );
  return response;
}

export async function updateEmailNotifier(id, fields) {
  const response = await api.put(
    `/customer_service/api/reservation_notifier_email/${id}/`,
    fields,
  );
  return response;
}

export async function deleteEmailNotifier(id) {
  const response = await api.delete(
    `/customer_service/api/reservation_notifier_email/${id}/`,
  );
  return response;
}

/************* Push Notification ***********/

export async function fetchPushNotification({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/notification/api/v1/admin/notifications/?page=${page}&page_size=${pageSize}`,
  );
  const notifications = await response.data;
  return notifications;
}

export async function createPushNotification(fields) {
  const response = await api.post(
    `/notification/api/v1/admin/notifications/`,
    fields,
  );
  return response;
}

/************* Banner Ads ***********/

export async function fetchBannerAds({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/adminapp/banners/?page=${page}&page_size=${pageSize}`,
  );
  const ads = await response.data;
  return ads;
}

export async function createBannerAds(fields) {
  const response = await api.post(
    `/adminapp/banners/`,
    fields,
  );
  return response;
}

export async function updateBannerAds({ id, fields }) {
  const response = await api.put(
    `/adminapp/banners/${id}/`,
    fields,
  );
  return response;
}

export async function deleteBannerAds(id) {
  const response = await api.delete(`/adminapp/banners/${id}/`);
  return response;
}

/************* Tour Management ***********/

export async function fetchDashboardStats() {
  const response = await api.get(
    `/tour/api/v1/admin/platform-dashboard/stats/`,
  );
  const stats = await response.data;
  return stats;
}

export async function fetchDashboardTrends() {
  const response = await api.get(
    `/tour/api/v1/admin/platform-dashboard/trends/`,
  );
  const stats = await response.data;
  return stats;
}

export async function fetchTourAgents({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/tour/api/v1/admin/agents/?page=${page}&page_size=${pageSize}`,
  );
  const agents = await response.data;
  return agents;
}

export async function fetchTourAgentDetail(id) {
  const response = await api.get(
    `/tour/api/v1/admin/agents/${id}/`,
  );
  const agent = await response.data;
  return agent;
}

export async function createTourAgent(fields) {
  const response = await api.post(
    `/tour/api/v1/admin/agents/`,
    fields,
  );
  return response;
}

export async function updateTourAgent({ id, fields }) {
  const response = await api.put(
    `/tour/api/v1/admin/agents/${id}/`,
    fields,
  );
  return response;
}

export async function deleteTourAgent(id) {
  const response = await api.delete(`/tour/api/v1/admin/agents/${id}/`);
  return response;
}

// *********** Tour Booking ***********

export async function fetchTourBooking({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/tour/api/v1/admin/bookings/?page=${page}&page_size=${pageSize}`,
  );
  const agents = await response.data;
  return agents;
}

export async function fetchTourBookingDetail(id) {
  const response = await api.get(
    `/tour/api/v1/admin/bookings/${id}/`,
  );
  const agent = await response.data;
  return agent;
}

export async function createTourBookingOverride(id) {
  const response = await api.post(
    `/tour/api/v1/admin/bookings/${id}/override/`,
  );
  return response;
}

// *********** Tours ***********

export async function fetchTours({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/tour/api/v1/admin/tours/?page=${page}&page_size=${pageSize}`,
  );
  const tours = await response.data;
  return tours;
}

export async function fetchToursDetail(id) {
  const response = await api.get(
    `/tour/api/v1/admin/tours/${id}/`,
  );
  const tour = await response.data;
  return tour;
}

// *********** disputes ***********

export async function fetchDisputes({ page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/tour/api/v1/admin/disputes/?page=${page}&page_size=${pageSize}`,
  );
  const disputes = await response.data;
  return disputes;
}

export async function fetchDisputeDetail(id) {
  const response = await api.get(
    `/tour/api/v1/admin/disputes/${id}/`,
  );
  const dispute = await response.data;
  return dispute;
}

export async function resolveDispute(id) {
  const response = await api.post(
    `/tour/api/v1/admin/disputes/${id}/resolve/`,
  );
  return response;
}
